export enum StatusProjektu {
    przygotowanie,
    realizacja,
    zakonczony,
    zarchiwizowany
}